export default "__VITE_ASSET__94002fbc__"